import React from 'react';
import styled from '@emotion/styled';
import {
  Checkbox,
  StarRating,
  Typography,
} from '@trustpilot/businessapp-patternlibrary';

interface StarSelectorProps {
  selectedStars: number[];
  onSelect: (star: number) => void;
  onSelectAll: (selected: boolean) => void;
}

const Container = styled.div`
  margin-bottom: 24px;
`;

const Title = styled(Typography)`
  margin-bottom: var(--CDS-spacing-m);
`;

const Stars = styled.div`
  display: grid;
  grid-row-gap: 8px;
  padding: 10px 16px;
`;

const StarCheckbox = styled.div`
  div {
    top: -2px;
  }
`;

const STARS: (1 | 2 | 3 | 4 | 5)[] = [1, 2, 3, 4, 5];

const StarSelector = ({ onSelect, onSelectAll, selectedStars }: StarSelectorProps) => {
  return (
    <Container>
      <Title variant="heading-s">Select review ratings</Title>
      <Checkbox
        checked={selectedStars.length === STARS.length}
        indeterminate={
          selectedStars.length > 0 && selectedStars.length < STARS.length
        }
        onChange={() => onSelectAll(selectedStars.length !== STARS.length)}
      >
        All ratings
      </Checkbox>
      <Stars>
        {STARS.map((star) => (
          <StarCheckbox key={star}>
            <Checkbox
              onChange={() => onSelect(star)}
              checked={selectedStars.includes(star)}
            >
              <StarRating size="small" rating={star} />
            </Checkbox>
          </StarCheckbox>
        ))}
      </Stars>
    </Container>
  );
};

export default StarSelector;
